import styles from "./Boxes.module.css";

interface Props {
  number: string;
}

const PhoneLink = ({ number }: Props) => {
  const digits = number.replace(/\s/g, "");
  return (
    <a href={`tel:${digits}`} className={styles.phone}>
      {number}
    </a>
  );
};

export default PhoneLink;
